module.exports = "<am-deck></am-deck>\n<topbar />\n<menubar ng-class=\"{ open: menuOpen }\" />\n<ui-view id=\"content-view\" class=\"flexible-container\" />"